import {Injectable} from "@angular/core";
import {HttpEvent, HttpHandler, HttpInterceptor,HttpRequest,HttpResponse,HttpErrorResponse} from '@angular/common/http';
import {Observable, throwError, BehaviorSubject} from "rxjs";
import {catchError} from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class ErrorsService implements HttpInterceptor {

  loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private router : Router) {
  }
 showAlertService(data : string) {
      if(!data){
          return 'Oh no!!! Algo salió mal... Error inesperado'
      }
      try {
          // El mensaje de error esta en un json y hay que serealizarlo
          var text = JSON.parse(data);
          return text.message;
      } catch (e) {
          // El mensaje es un string simple
          return data;
      }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error) => {
        let errorText = this.showAlertService(error.error.message);
          if ([0].indexOf(error.status) !== -1) {
              errorText = 'Detectamos intermitencia en tu conexión. Por favor intentalo de nuevo.';
          }
        if ([401, 403].indexOf(error.status) !== -1) {
          this.loggedIn.next(false);
          localStorage.clear();
          errorText = 'Lo sentimos. Su sesión ya expiró';
          this.router.navigate(['/login']);
        }
        if ([406].indexOf(error.status) !== -1) {
          errorText = error.error;
        }
        return throwError(errorText);
      })
    )
  }
}
